module.exports = __webpack_public_path__ + "static/media/0003.aeb3cb01.jpg";